import type ItineraryPackage from '@itinerary/ItineraryPackage';

export function useHandleEvents(pkg: ItineraryPackage, index: number) {
    const gtm = useGtm();
    const analyticsStore = useAnalyticsStore();
    const searchFormStore = useSearchFormStore();
    const currentModule = useCurrentItineraryModule();
    const authStore = useAuthStore();
    if (pkg.isTripPackage()) {
        gtm?.trackEvent({ event: 'add_to_cart' });
    }
    gtm?.trackEvent({
        event: 'srp-click reserve',
    });
    analyticsStore.trackAll('select', {
        isDiscounted: `${pkg.selectedPrices?.some(p => p.isDiscounted)}`,
        isFeatured: 'false',
        isSameService: `${
            pkg.reserveType === searchFormStore.firstReserveType
        }`,
        isMasir: 'false',
        creationSource: authStore.siteSourceId,
        whiteLabel: useSiteConfigs().title,
        reserveType: pkg.reserveType,
        selectedIndex: index,
        selectedSort: currentModule.value.sortBy,
        ...(pkg.isTripPackage() && pkg.firstTrip?.corporationInfo?.title
            ? { corporationTitle: pkg.firstTrip.corporationInfo.title }
            : {}),
    });
}
